import { Text } from '@mantine/core';
import PropTypes from 'prop-types';
import React from 'react';
import IconAlertWarning from '../../components/icons/IconAlertWarning';
import styles from './periodNotice.scoped.css';

export default function PeriodNotice({ children }) {
  return (
    <div className={styles.periodNotice}>
      <IconAlertWarning className={styles.periodNoticeIcon} />
      <Text className={styles.periodNoticeText}>{children}</Text>
    </div>
  );
}

PeriodNotice.propTypes = {
  children: PropTypes.node.isRequired,
};
